export default "__VITE_ASSET__BAk1oXcQ__"